import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { Bus, SiteConfigManager } from '@atlas/core';
import { casinoRoutes, COMPONENT_TYPES, paymentRoutes } from '@atlas/routing';

const { CASINO, CLIENT_PROFILE } = COMPONENT_TYPES;
const { game } = casinoRoutes;
const { deposit } = paymentRoutes;

export const DEFAULT_SHOW_INACTIVE_TIME = 60000;
export const LONG_SHOW_INACTIVE_TIME = 3600000;

let timeoutId;
const events = ['keypress', 'touchstart', 'click'];

const useInactivityTimer = (timeoutMs = DEFAULT_SHOW_INACTIVE_TIME) => {
  const clientProfilePath = SiteConfigManager.getComponentPath(CLIENT_PROFILE);
  const casinoProfilePath = SiteConfigManager.getComponentPath(CASINO);
  const [isInactive, setIsInactive] = useState(false);
  const [isActiveLegitimuz, setActiveLegitimuz] = useState(false);
  const { pathname, search } = useLocation();

  const timeToShowLogoutPopup =
    isActiveLegitimuz ||
    search.indexOf('cmd=withdrawal') > -1 ||
    pathname.indexOf(`${casinoProfilePath}/${game}/`) > -1 ||
    pathname.indexOf(`${clientProfilePath}/${deposit}/`) > -1
      ? LONG_SHOW_INACTIVE_TIME
      : timeoutMs;

  const resetTimer = () => {
    timeoutId && clearTimeout(timeoutId);
    setIsInactive(false);

    timeoutId = setTimeout(() => {
      setIsInactive(true);
    }, timeToShowLogoutPopup);
  };

  useEffect(() => {
    const setLegitimuzStatus = action => setActiveLegitimuz(action.isShow);

    Bus.on('legitimuz_toggle', setLegitimuzStatus);

    return () => {
      Bus.off('legitimuz_toggle', setLegitimuzStatus);
    };
  }, []);

  useEffect(() => {
    resetTimer();

    events.forEach(event => {
      document.removeEventListener(event, resetTimer, true);
    });

    events.forEach(event => {
      document.addEventListener(event, resetTimer, true);
    });
    return () => {
      timeoutId && clearTimeout(timeoutId);
      events.forEach(event => {
        document.removeEventListener(event, resetTimer, true);
      });
    };
  }, [timeToShowLogoutPopup]);

  return isInactive;
};

export default useInactivityTimer;
